import React from "react";

import ConnectWithUs from "@/components/connect/connect-with-us";

import Head from "next/head";
import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

const connect = () => {
  return (
    <>
      <Head>
        <title>{seoData.CONNECT.title}</title>
        <SeoMetaData data={seoData.CONNECT} />
      </Head>

      <ConnectWithUs />
    </>
  );
};

export default connect;
